import { eachDayOfInterval, endOfDay, isSameDay, isSameMonth, isSunday, isToday, isWithinInterval, nextSaturday, previousSunday, startOfDay, } from 'date-fns';
import { DAYS_PER_WEEK, WEEKS_TO_RENDER } from './DatePicker.constants';
export const getDayNames = () => {
    const date = new Date();
    const dayNames = [...Array(DAYS_PER_WEEK).keys()].reduce((acc, _cV, idx) => {
        const incrementedDate = new Date();
        incrementedDate.setDate(date.getDate() + idx);
        acc[incrementedDate.getDay()] = incrementedDate.toLocaleDateString(undefined, {
            weekday: 'long',
        });
        return acc;
    }, []);
    return dayNames;
};
export const datesAreEqual = (firstDate, secondDate) => isSameDay(firstDate, secondDate);
export const getCurrentYear = () => {
    return new Date().getFullYear();
};
export const getCurrentMonth = () => {
    return new Date().getMonth();
};
export const getDateParams = (date) => {
    const { day, month, year } = {
        day: date.getDay(),
        month: date.getMonth(),
        year: date.getFullYear(),
    };
    return {
        day,
        month,
        year,
    };
};
export const getDisplayDates = (focusedDate) => {
    const { month, year } = getDateParams(focusedDate);
    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);
    // take into account if firstDay is Sunday
    const start = isSunday(firstDayOfMonth)
        ? firstDayOfMonth
        : previousSunday(firstDayOfMonth);
    const end = nextSaturday(lastDayOfMonth);
    let accumulatedDays = eachDayOfInterval({ start, end });
    const totalDisplayDays = WEEKS_TO_RENDER * DAYS_PER_WEEK;
    if (accumulatedDays.length < totalDisplayDays) {
        const daysToFill = totalDisplayDays - accumulatedDays.length;
        accumulatedDays = eachDayOfInterval({
            start,
            end: end.setDate(end.getDate() + daysToFill),
        });
    }
    return accumulatedDays;
};
// used to derive styles
export const getDateProps = ({ date, focusedDate, max, min, selectedDate, }) => {
    const { year } = getDateParams(date);
    return {
        isToday: isToday(date),
        isInCurrentMonth: isSameMonth(date, focusedDate),
        isSelected: datesAreEqual(date, selectedDate),
        isDisabled: !isWithinInterval(date, {
            // NaN doesn't work - adding/subtracting 100 years
            start: (min && startOfDay(min)) || new Date(year - 100, 0),
            end: (max && endOfDay(max)) || new Date(year + 100, 0),
        }),
    };
};
